/**
 * "Change in Settings → Who gets what" (1.6.9, D-1.6.9-1): a setting is changed in one place, Admin → Settings.
 * Anywhere else in the app that shows a setting's value — or says it is not set — carries this link instead of a
 * second editor. It opens the Settings page at that setting (its title and subtitle opened, its row marked). A
 * person who may not change it sees the words "The administrator changes this in Settings." and no link.
 * Which title a setting is under, and who may change it, come from the catalog (shared/settings-catalog.ts).
 */
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { hasAnyRole } from '@shared/roles';
import { catalogEntry, settingsLink } from '@shared/settings-catalog';
import { useMe } from '@/auth/useMe';

export function ChangeInSettings({ code, testId }: { code: string; testId?: string }) {
  const { t } = useTranslation();
  const me = useMe();
  const def = catalogEntry(code);
  if (!def) return null;
  const id = testId ?? `change-in-settings-${code}`;
  if (!hasAnyRole(me.data?.roles, def.change)) {
    return (
      <span className="help set169-change" data-testid={id}>
        {t('set169.change.admin')}
      </span>
    );
  }
  return (
    <Link className="set169-change" to={settingsLink(code)} data-testid={id}>
      {t('set169.change.link', { title: t(`setgroup.${def.group}.title`) })}
    </Link>
  );
}
